import React from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";


import {createRoomMessageMedia} from "../../../../../creators/room.message";

import Icon from "../../../../components/Icon";
import "./RoomSendMessageMedias.scss";
import UploadMultipleGalleryChat from "../../../../components/upload/UploadMultipleGalleryChat";
import _ from "lodash";
// import {faFileImage, faImage} from "@fortawesome/free-solid-svg-icons";
// import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


class RoomSendMessageMedias extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            multipleRawFiles: [],
            filesList : [],
            uploadSuccessId : [],
            toggleMedia : false
        };



        this.handleFiles = this.handleFiles.bind(this);
        this.getUploadData = this.getUploadData.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onClose = this.onClose.bind(this);

        if(this.props.onRef){
            this.props.onRef(this)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(_.get(this.props,"roomId") !== _.get(prevProps,"roomId")){
            this.onClose();
        }
    }

    handleFiles() {
        let multipleRawFiles = this.state.multipleRawFiles;
        let newFiles = document.getElementById('multipleUploadInputChat').files;
        newFiles = Object.values(newFiles);
        multipleRawFiles = [...multipleRawFiles, ...newFiles];
        if(typeof this.props.handleToogleUpload === "function" && !this.state.toggleMedia){
            this.props.handleToogleUpload(true);
        }
        this.setState({multipleRawFiles, toggleMedia : true}, () => document.getElementById("multipleUploadInputChat").value = "");
    }



    handleRemove(fileId){
        let filesList = this.state.filesList;
        filesList = filesList.filter(item => item._id.toString() !== fileId.toString());
        let toggleMedia = filesList.length ? true : false;
        if(typeof this.props.handleToogleUpload === "function"){
            this.props.handleToogleUpload(toggleMedia);
        }
        this.setState({filesList, toggleMedia});
    }

    getUploadData(data) {
        // SUCCESS UPLOAD TO SEND
        /*
        let multipleRawFiles = this.state.multipleRawFiles;
        let filesList = this.state.filesList;
        let uploadSuccessId = this.state.uploadSuccessId;
        //console.log(data, multipleRawFiles);
        filesList.push(data);


        if(data._id){
            uploadSuccessId.push(data._id);
        }
        if(uploadSuccessId.length === multipleRawFiles.length){
            uploadSuccessId = [];
            multipleRawFiles = [];
        }
        this.setState({filesList, multipleRawFiles, uploadSuccessId});
       */


        let uploadSuccessId = this.state.uploadSuccessId;
        let multipleRawFiles = this.state.multipleRawFiles;


        this.props.createRoomMessageMedia(this.props.roomId, {fileId : data._id});
        if(data._id){
            uploadSuccessId.push(data._id);
        }
        if(uploadSuccessId.length === multipleRawFiles.length){
            uploadSuccessId = [];
            multipleRawFiles = [];
            this.onClose();
        }
        this.setState({ multipleRawFiles, uploadSuccessId});
    }


    onSubmit(){
        /*let fileIds = this.state.filesList.map(file => file._id);
        fileIds.forEach(fileId=>{
            this.props.createRoomMessageMedia(this.props.roomId, {fileId : fileId});
        });*/

        this.setState({filesList : []});
        /*if(fileIds.length){
            this.props.createRoomMessageMedia(this.props.roomId, {fileIds});
        }


*/
       if(this.state.multipleRawFiles.length === 0){
           this.onClose();
       }
    }

    onClose(){
        if(typeof this.props.handleToogleUpload === "function"){
            this.props.handleToogleUpload(false);
        }
        this.setState({filesList : [], multipleRawFiles : [], toggleMedia : false});
    }


    render() {
//console.log(this.state.multipleRawFiles, this.state.filesList, this.state.uploadSuccessId);
        let widthContent = document.querySelector('.chat-header');
        let maxWidth = widthContent && widthContent.offsetWidth > 0 ? `${widthContent.offsetWidth-10}px` : "100vw";

        return (
            <div id={"room-send-message-medias"}>
                {this.state.toggleMedia ? <div className="row attachement-container">
                    <div className={"overflow-container"} style={{maxWidth : maxWidth}}>

                        <div className={"medias"}>
                            {this.state.multipleRawFiles.map((item, index) => (
                                <UploadMultipleGalleryChat uploadPath={"/rooms/uploads"}
                                   onSuccess={this.getUploadData}
                                   multFileData={item}
                                   index={index}
                                   //toggleMedia={this.state.toggleMedia}
                                   key={index}/>
                                )
                            )}
                            {this.state.filesList.map(file => (
                                <div key={file._id} className="attachement-block" >
                                    <div className="layer"><span><Icon type="close" callback={() =>this.handleRemove(file._id)} /></span></div>
                                    <div className={"img-preview"} style={{backgroundImage: `url(${file.preview})`}} />
                                </div>
                            ))}

                        </div>
                    </div>
                </div> : null}
                <div className={"icon-input"}>
                    <input type="file"
                           id="multipleUploadInputChat"
                           style={{display: 'none'}}
                           accept="image/jpeg, image/png, image/gif, video/mp4, video/flv, video/mpeg, video/mkv, video/mov, video/qt, video/quicktime, video/wmv, video/avi"
                           multiple
                           onChange={() => this.handleFiles(this.files)}
                    />
                    <label htmlFor={"multipleUploadInputChat"}>
                        <Icon type={"medias"} className="icon-attach"/>
                    </label>
                </div>

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUserId: state.currentUser.data && state.currentUser.data._id,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    createRoomMessageMedia
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RoomSendMessageMedias);
